// ! This file was auto-generated from the atlas OpenAPI schema. Do not override this file.
export const Tags = {
    Guidelines: "Guidelines",
    Healthchecks: "Healthchecks",
    Playbooks: "Playbooks",
    Question_Groups: "Question Groups",
    Saved_Questions: "Saved Questions"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
